import { ProjectReviewSectionType } from './types';

export const PROJECT_REVIEW_FINALIZE_ERROR_MESSAGE = 'Failed to finalize project review. Please try again.';
export const PROJECT_REVIEW_FINALIZED_SUCCESS_MESSAGE =
  'Project review has been finalized. The review results are available in the Timeline.';
export const PROJECT_REVIEW_FINALIZED_TIMELINE_LINK_LABEL = 'View the Timeline entry';

export const PROJECT_REVIEW_SECTION_LABELS: Record<ProjectReviewSectionType, string> = {
  PROJECT_MANAGEMENT: 'Project management control',
  COMMERCIAL: 'Commercial control',
  ENGINEERING: 'Engineering control',
  STAFFING: 'Staffing control',
};
